<template>
<div class="chapter">
<div class="inner_page">
      ﻿


<meta content="text/html; charset=utf-8" http-equiv="Content-Type"/>
<title>Remembering Farley</title>
<link href="style.css" rel="stylesheet" type="text/css"/>
<p class="textnc"> </p>
<p class="textnc"> </p>
<p class="textnc"> </p>
<p class="textnc"> </p>
<p class="textnc"> </p>
<p class="textnc"> </p>
<p class="textnc"><span class="bold">Other Books by Jef Mallett</span></p>
<p class="textnc"> </p>
<p class="textnc"><em class="italic">Frazz: Live at Bryson Elementary</em></p>
<p class="textnc"> </p>
<p class="textnc"><em class="italic">99% Perspiration</em></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Frazz-003.vue?19205450